import React from 'react'
import HelpTutorial, { HelpTutorialSlide, useHelpTutorial } from '@fs/zion-help-tutorial'
import slides from 'assets/index-status-tutorial'
import trans from './IndexStatusTutorial.trans'

export default function IndexStatusTutorial() {
  const helpTutorial = useHelpTutorial('lightyear-react.indexed-status-tutorial')

  return (
    <HelpTutorial
      tutorialId="lightyear-react.indexed-status-tutorial"
      tutorialTitle={trans.title()}
      tutorialDescription={trans.description()}
      {...helpTutorial}
    >
      {trans.slides.map((slide, i) => (
        <HelpTutorialSlide
          imageSrc={slides[i]}
          imageAlt=""
          heading={slide.heading()}
          content={slide.content()}
          key={slide.heading().substring(0, 5) + slide.heading().length}
          imgBleed
        />
      ))}
    </HelpTutorial>
  )
}
